import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { Button } from '../ui/button'
import { cn } from '@/lib/utils'
import type { TimeFramePreset } from '@/lib/types'

interface TimeFilterProps {
  value: TimeFramePreset
  onChange: (value: TimeFramePreset) => void
  className?: string
}

const timeOptions = [
  { value: 'all' as const, label: 'Alle scans' },
  { value: 'last_15_minutes' as const, label: 'Laatste 15 minuten' },
  { value: 'last_30_minutes' as const, label: 'Laatste 30 minuten' },
  { value: 'last_45_minutes' as const, label: 'Laatste 45 minuten' },
  { value: 'last_1_hour' as const, label: 'Laatste uur' },
  { value: 'last_24_hours' as const, label: 'Laatste 24 uur' },
] as const

export function TimeFilter({ value, onChange, className }: TimeFilterProps) {
  const [isOpen, setIsOpen] = useState(false)

  const selectedOption = timeOptions.find(opt => opt.value === value)

  return (
    <div className={cn('relative', className)}>
      <Button
        variant="outline"
        onClick={() => setIsOpen(!isOpen)}
        className="justify-between min-w-[180px] w-full"
      >
        {selectedOption?.label}
        <ChevronDown className={cn('w-4 h-4 transition-transform', isOpen && 'rotate-180')} />
      </Button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
          <div className="absolute top-full left-0 z-20 mt-1 w-full bg-white border border-input rounded-md shadow-lg">
            {timeOptions.map(option => (
              <button
                key={option.value}
                className={cn(
                  'w-full px-3 py-2 text-left text-sm hover:bg-accent hover:text-accent-foreground',
                  'first:rounded-t-md last:rounded-b-md',
                  value === option.value && 'bg-accent text-accent-foreground'
                )}
                onClick={() => {
                  onChange(option.value)
                  setIsOpen(false)
                }}
              >
                {option.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  )
}
